import React, { useState } from 'react'
import axios from "../../../../axios";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { X } from "lucide-react";
export default function JoinNowbtn({ event, obj }) {

  const [boradCastLink, setBoradCastLink] = useState('');
  const [showModal, setShowModal] = useState(false);
  const data = JSON.parse(localStorage.getItem("breathForStudent"));

  const onJoinNowClick = async (e) => {
    e.stopPropagation();
    let _id;
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        _id = element.value;
      }
    });
    try {
      if (data?.school?.liveClassType === "broadcast") {
        const response = await axios.get(
          `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${data?.id}&school_id=${data?.school?.id}`
        );
        if (response.data.data) {
          setBoradCastLink(response.data.data)
          setShowModal(true);
        }
      } else {
        const res = await axios.get(
          `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${data?.id}&school_id=${data?.school?.id}`
        );
        if (res.data.data) {
          const win = window.open(res.data.data, "_blank");
          if (win) win.focus();
        }
      }

    } catch (error) {
      console.error("Join class error:", error);
      toast.error("Meeting is not started!!");
    }
  };
  return (
    <div>
      <div id="card_body_new">
        <button type="button" data-dismiss="modal" id='PopUpBtn_Sanskrt' class="btn btn" onClick={(e) => onJoinNowClick(e)}>JOIN NOW</button>
      </div>
      {showModal && (
        <div className="ContainerSubmitedSucess2 ">
          <div className="SubContainerSubmitedSucessBoradcast">
            <div className="flex justify-between items-center">
              <h4 className="text-blue-950 font-semibold">Online Session</h4>
              <div className="mb-2 cursor-pointer"><X color="black" onClick={(e) => {
                e.stopPropagation();
                setShowModal(false)
              }} /></div>
            </div>
            <div>
              <iframe
                src={boradCastLink}
                width="900"
                height="500"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>

          </div>
        </div >
      )}
    </div>
  )
}
